import { PropsWithChildren } from "react";
import { Flex } from "@chakra-ui/react";

export function PublicLayout({ children }: PropsWithChildren<{}>) {
  return (
    <Flex bgColor="blue.900" justify="center" align="center" h="100vh">
  {children}
    </Flex>
  );
}